import DescriptionIcon from '@material-ui/icons/Description';
import GrabIcon from '@svg/grab.svg';
import React from 'react';
import { DocumentDownloadLink } from './DocumentDownloadLink';
import {
  ChevronSlot,
  DocumentNameCellRoot,
  DocumentRowIcon,
  FileDragHandle,
} from './styled';

interface DocumentFileNameCellProps {
  name: string;
  downloadUrl: string;
  indented?: boolean;
  isDraggable?: boolean;
}

export function DocumentFileNameCell({
  name,
  downloadUrl,
  indented = false,
  isDraggable = false,
}: DocumentFileNameCellProps) {
  const icon = (
    <DocumentRowIcon $variant="file">
      <DescriptionIcon titleAccess="File" />
    </DocumentRowIcon>
  );

  return (
    <DocumentNameCellRoot $indented={indented}>
      {isDraggable && (
        <FileDragHandle aria-hidden $indented={indented}>
          <GrabIcon />
        </FileDragHandle>
      )}
      {indented ? icon : <ChevronSlot>{icon}</ChevronSlot>}
      <DocumentDownloadLink downloadUrl={downloadUrl}>
        {name}
      </DocumentDownloadLink>
    </DocumentNameCellRoot>
  );
}
